import { isAuthenticated } from '@/utils/auth';

function readStoredUser() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem('userData');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function accountEmailFromUser(user) {
  const email = String(user?.email || '').trim();
  return email || null;
}

/** Signed-in account email from localStorage, including partner and staff sessions. */
export function readSelfServiceEmailFromStorage() {
  if (!isAuthenticated()) return null;
  return accountEmailFromUser(readStoredUser());
}

export function selfServiceEmailFromProfile(user) {
  return accountEmailFromUser(user);
}

/** Keep the calculator email aligned with the signed-in self-service account. */
export function withLockedAccountEmail(formData, email) {
  if (!email || !formData || typeof formData !== 'object') return formData;
  const hasPolicyholder =
    formData.policyholder && typeof formData.policyholder === 'object';
  const emailMatches = formData.email === email;
  const policyholderMatches =
    !hasPolicyholder || formData.policyholder.email === email;
  if (emailMatches && policyholderMatches) return formData;
  return {
    ...formData,
    email,
    ...(hasPolicyholder
      ? { policyholder: { ...formData.policyholder, email } }
      : {}),
  };
}
